/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const TaskList56 = (props: SVGProps) => (
    <AccessibleSVG width={56} height={56} viewBox="0 0 56 56" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill={vars.bdlBoxBlue10}
                d="M8 31c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zM44 4a8 8 0 110 16 8 8 0 010-16z"
            />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M45 15v30c0 2.21-1.79 4-4 4H15c-2.21 0-4-1.79-4-4V15c0-1.065.416-2.033 1.095-2.75-.062.24-.095.491-.095.75v32a3 3 0 003 3h26a3 3 0 003-3V13c0-.259-.033-.51-.094-.75A3.99 3.99 0 0145 15z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M41 9H15a6 6 0 00-6 6v30a6 6 0 006 6h26a6 6 0 006-6V15a6 6 0 00-6-6zm0 2c2.21 0 4 1.79 4 4v30c0 2.21-1.79 4-4 4H15c-2.21 0-4-1.79-4-4V15c0-2.21 1.79-4 4-4h26z"
            />
            <path
                fill={vars.white}
                fillRule="nonzero"
                d="M41 11a2 2 0 012 2v32a2 2 0 01-2 2H15a2 2 0 01-2-2V13a2 2 0 012-2h26z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M41 10H15a3 3 0 00-3 3v32a3 3 0 003 3h26a3 3 0 003-3V13a3 3 0 00-3-3zm0 1a2 2 0 012 2v32a2 2 0 01-2 2H15a2 2 0 01-2-2V13a2 2 0 012-2h26z"
            />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M28 5a3 3 0 012.995 2.824L31 8h3a1 1 0 011 1v3a1 1 0 01-1 1H22a1 1 0 01-1-1V9a1 1 0 011-1h3a3 3 0 013-3z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M20 38a2 2 0 012 2v1a2 2 0 01-2 2h-1a2 2 0 01-2-2v-1a2 2 0 012-2h1zm18.5 2a.5.5 0 010 1h-13a.5.5 0 010-1h13zM20 40h-1v1h1v-1zm0-9a2 2 0 012 2v1a2 2 0 01-2 2h-1a2 2 0 01-2-2v-1a2 2 0 012-2h1zm18.5 2a.5.5 0 010 1h-13a.5.5 0 010-1h13zM20 33h-1v1h1v-1zm0-9a2 2 0 012 2v1a2 2 0 01-2 2h-1a2 2 0 01-2-2v-1a2 2 0 012-2h1zm0 2h-1v1h1v-1zm18.5 0a.5.5 0 010 1h-13a.5.5 0 010-1h13zm-12-7a.5.5 0 010 1h-9a.5.5 0 010-1h9zm12 0a.5.5 0 010 1h-5a.5.5 0 010-1h5z"
            />
            <path fill={vars.bdlBoxBlue10} fillRule="nonzero" d="M20 40h-1v1h1zm0-7h-1v1h1zm0-7h-1v1h1z" />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M28 3a4.985 4.985 0 014.521 2.884l.051.116H34a3 3 0 012.995 2.824L37 9v3a3 3 0 01-3 3H22a3 3 0 01-3-3V9a3 3 0 013-3h1.416l.018-.04a5 5 0 014.35-2.955zm0 2a3 3 0 00-3 3h-3a1 1 0 00-1 1v3a1 1 0 001 1h12a1 1 0 001-1V9a1 1 0 00-1-1h-3l-.005-.176A3 3 0 0028 5zm2.5 5a.5.5 0 010 1h-5a.5.5 0 010-1h5zM28 7a.5.5 0 110 1 .5.5 0 010-1z"
            />
        </g>
    </AccessibleSVG>
);

export default TaskList56;
